import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'BelleCore',
  brandName: 'BelleCore',
  description: 'Sistema de agendamento para esteticistas',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Sala de estética moderna',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Profissional realizando tratamento de pele',
  },
  testimonials: [
    {
      name: 'Joana Silva',
      role: 'Esteticista',
      text: 'O BelleCore transformou a gestão da minha agenda. As minhas clientes adoram a autonomia para marcar!',
      image: testimonial1,
    },
    {
      name: 'Carla Martins',
      role: 'Cliente Frequente',
      text: 'Finalmente um sistema que me permite marcar os meus tratamentos a qualquer hora, sem complicações.',
      image: testimonial2,
    },
    {
      name: 'Patrícia Gomes',
      role: 'Dona de Salão de Beleza',
      text: 'Reduzimos as faltas em 50% graças aos lembretes automáticos. Recomendo vivamente!',
      image: testimonial3,
    },
  ],
  terminology: {
    professional: 'esteticista',
    professionals: 'esteticistas',
    business: 'salão',
    businesses: 'salões',
    service: 'tratamento',
    services: 'tratamentos',
    client: 'cliente',
    clients: 'clientes',
    appointment: 'tratamento',
    appointments: 'tratamentos',
  },
  homepage: {
    hero: {
      badge: 'Estética Profissional',
      title: 'Realce a beleza natural com BelleCore',
      description: 'Gerencie seus tratamentos estéticos e proporcione experiências únicas às suas clientes com o BelleCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Agendar Demonstração',
      features: ['Setup em 5 minutos', 'App mobile incluído'],
    },
    statistics: [
      { value: '320+', label: 'Esteticistas' },
      { value: '28k+', label: 'Tratamentos Realizados' },
      { value: '96%', label: 'Satisfação' },
    ],
    painPoints: [
      {
        title: 'Agenda Sobrelotada',
        description: 'Gerir horários de múltiplos tratamentos manualmente causa confusão e perda de clientes.',
        icon: 'Calendar',
        quote: {
          text: 'Antes do BelleCore perdia 3 horas diárias organizando os horários dos meus 25 tratamentos',
          author: 'Sofia Pereira',
          business: 'Belle Estética',
        },
      },
      {
        title: 'Faltas de Última Hora',
        description: 'Clientes que cancelam em cima da hora causam períodos vazios e perda de rendimento.',
        icon: 'Users',
        stats: [
          { label: 'Taxa de cancelamentos sem sistema:', value: '25%' },
          { label: 'Perda mensal de faturação:', value: '600€+' },
        ],
      },
      {
        title: 'Controlo de Produtos',
        description: 'Sem controlo de stock, produtos em falta afetam a qualidade dos tratamentos.',
        icon: 'Package',
        quote: {
          text: 'Com o controlo de produtos nunca mais fiquei sem material no meio de um tratamento',
          author: 'Ana Costa',
          business: 'Estética & Bem-estar',
        },
      },
    ],
    solution: {
      badge: 'A Solução',
      title: 'BelleCore: A sua parceira de beleza',
      description: 'Tecnologia desenvolvida para esteticistas que querem oferecer experiências excepcionais.',
      features: [
        {
          title: 'Agendamento Personalizado',
          description: 'Clientes marcam tratamentos respeitando tempo e especialização de cada procedimento.',
        },
        {
          title: 'Histórico de Tratamentos',
          description: 'Mantenha registo completo de todos os procedimentos e evolução da cliente.',
        },
        {
          title: 'Lembretes de Cuidados',
          description: 'Envie lembretes personalizados de cuidados pós-tratamento.',
        },
      ],
    },
    testimonials: {
      title: 'O que as esteticistas dizem',
      description: 'Esteticistas que confiam no BelleCore para gestão profissional.',
    },
    finalCta: {
      title: 'Pronta para transformar seu salão?',
      description: 'Junte-se às esteticistas que já otimizaram sua gestão com o BelleCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Ver Demonstração',
    },
    contact: {
      title: 'Fale Conosco',
    },
  },
  auth: {
    register: {
      title: 'Criar uma conta',
      description: 'Preencha os dados abaixo para se registrar',
      inviteDescription: 'Crie sua conta para aceitar o convite de esteticista',
      subscriptionDescription: 'Crie sua conta para finalizar sua assinatura',
      inviteCodeLabel: 'Você está usando um código de convite',
      subscriptionLabel: 'Você selecionou um plano de assinatura',
    },
    login: {
      title: 'Entrar na conta',
      description: 'Digite suas credenciais para acessar',
    },
  },
}

export default config
